import { render, staticRenderFns } from "./majorObjectAdd.vue?vue&type=template&id=4979fa64"
import script from "./majorObjectAdd.vue?vue&type=script&lang=js"
export * from "./majorObjectAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4979fa64')) {
      api.createRecord('4979fa64', component.options)
    } else {
      api.reload('4979fa64', component.options)
    }
    module.hot.accept("./majorObjectAdd.vue?vue&type=template&id=4979fa64", function () {
      api.rerender('4979fa64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/object/majorObject/majorObjectAdd.vue"
export default component.exports